import areas from "./areas";
import banners from "./banners";
import boards from "./boards";
import center from "./center";
import counsels from "./counsels";
import experts from "./experts";
import fairs from "./fairs";
import forms from "./forms";
import me from "./me";
import message from "./message";
import setting from "./setting";
import shop from "./shop";
import terms from "./terms";
import users from "./users";
import popups from "./popups";

export default {
    areas,
    banners,
    boards,
    center,
    counsels,
    experts,
    fairs,
    forms,
    me,
    message,
    setting,
    shop,
    terms,
    users,
    popups
};
